import { useTranslation } from "@opendash/i18n";
import { $parse, CustomParseFieldProps } from "@opendash/plugin-parse";
import { Empty, Select, Tag } from "antd";
import React from "react";
type DateColumnCustomFieldProps = React.PropsWithChildren & {};
const DateColumnCustomField = (
  props: CustomParseFieldProps<DateColumnCustomFieldProps>
) => {
  const className = props.parseObject.get("query")?.className || "";
  const t = useTranslation();
  const schema = $parse.server.schema.find((c) => c.className === className);
  if (!schema) {
    return <Empty></Empty>;
  }
  const translationprefix =
    $parse.ui.getClassConfig(className)?.translationPrefix || "opendash:";

  const options = Object.keys(schema?.fields)
    .filter((fieldKey) => schema.fields[fieldKey].type === "Date")
    .map((field) => {
      const label = t(
        `${translationprefix}${className}.fields.${field}`,
        field
      );
      return {
        label: label,
        value: field,
      };
    });
  if (!props.setValue) {
    const label = t(
      `${translationprefix}${className}.fields.${props.value}`,
      props.value
    );
    return <Tag> {label}</Tag>;
  }
  return (
    <Select
      options={options}
      value={props.value}
      onChange={(val) => {
        props.setValue(val);
      }}
    ></Select>
  );
};

export default DateColumnCustomField;
export type { DateColumnCustomFieldProps };
